// REPLACE: replace with project name
const PROJECT_NAME = "sps";

export default PROJECT_NAME;
